const DarkWebExposureIcon = () => {
    return (
        <svg
            width={16}
            height={17}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_24_13764"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={16}
                height={17}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.53984 0.646447C4.63361 0.552678 4.76079 0.5 4.8934 0.5H11.1066C11.2392 0.5 11.3664 0.552678 11.4602 0.646447L15.8536 5.03984C15.9473 5.13361 16 5.26079 16 5.3934V11.6066C16 11.7392 15.9473 11.8664 15.8536 11.9602L11.4602 16.3536C11.3664 16.4473 11.2392 16.5 11.1066 16.5H4.8934C4.76079 16.5 4.63361 16.4473 4.53984 16.3536L0.146447 11.9602C0.0526784 11.8664 0 11.7392 0 11.6066V5.3934C0 5.26079 0.0526784 5.13361 0.146447 5.03984L4.53984 0.646447ZM5.1005 1.5L1 5.6005V11.3995L5.10051 15.5H10.8995L15 11.3995V5.60051L10.8995 1.5H5.1005Z"
                    fill="black"
                />
                <path
                    d="M7.00153 11.5C7.00153 10.9477 7.44924 10.5 8.00153 10.5C8.55381 10.5 9.00153 10.9477 9.00153 11.5C9.00153 12.0523 8.55381 12.5 8.00153 12.5C7.44924 12.5 7.00153 12.0523 7.00153 11.5Z"
                    fill="black"
                />
                <path
                    d="M7.09949 5.49504C7.04621 4.96228 7.46457 4.5 7.99998 4.5C8.5354 4.5 8.95376 4.96228 8.90048 5.49504L8.54974 9.00248C8.52149 9.28492 8.28383 9.5 7.99998 9.5C7.71614 9.5 7.47848 9.28492 7.45023 9.00248L7.09949 5.49504Z"
                    fill="black"
                />
            </mask>
            <g mask="url(#mask0_24_13764)">
                <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
            </g>
        </svg>

    );
}

export default DarkWebExposureIcon;